import { Badge, Card, Tabs } from '@shopify/polaris';
import { memo, useCallback, useState } from 'react';
import HeatMapBlocked from './Blocked';
import HeatMapVisited from './Visited';
import HeatMapRedirect from './Redirect';
import { HeatMapStyled } from './styled';
import userPlans from '@/hooks/userPlans';
import { useSelector } from 'react-redux';
import { dataSettingsSelector } from '@/redux/slice/dataSettings.slice';
import { useTranslation } from 'react-i18next';
const HeatMap = () => {
  const { userPlanFree } = userPlans();
  const dataSettings = useSelector(dataSettingsSelector);
  const { t } = useTranslation(['visitor_analytics']);
  const [selected, setSelected] = useState(0);
  const handleTabChange = useCallback((selectedTabIndex: number) => setSelected(selectedTabIndex), []);

  const tabs = [
    {
      id: 'visited',
      content: t('visitor_analytics:allowed_visitor_heatmap'),
      component: <HeatMapVisited />,
    },
    {
      id: 'blocked',
      content: t('visitor_analytics:blocked_visitor_heatmap'),
      component: <HeatMapBlocked />,
    },
    {
      id: 'redirect',
      content: t('visitor_analytics:redirected_visitor_heatmap'),
      component: <HeatMapRedirect />,
    },
  ];
  return (
    <HeatMapStyled>
      <Card padding={'100'}>
        <div className="card-container">
          <div className="d-flex align-center">
            <Tabs tabs={tabs} fitted selected={selected} onSelect={handleTabChange} />
            {userPlanFree && !dataSettings?.settings.enableVisitorAnalytics && (
              <div className="badge-demo">
                <Badge tone="enabled">{t('demo')}</Badge>
              </div>
            )}
          </div>
          {tabs[selected].component}
        </div>
      </Card>
    </HeatMapStyled>
  );
};
export default memo(HeatMap);
